module.exports = {
  bindings: {},
  controller: class {

    static $inject = [
      '$rootScope',
      '$timeout',
      'LoadingService',
    ];

    constructor($rootScope, $timeout, LoadingService) {
      this.$rootScope = $rootScope;
      this.$timeout = $timeout;
      this.LoadingService = LoadingService;

      this.loaded = true;

      const threshold = application.env === 'test' ? 0 : 500;

      this.$rootScope.$on('loading:started', () => {
        this.startTimestamp = new Date().getTime();
        this.loaded = false;
      });

      this.$rootScope.$on('loading:completed', () => {
        const loadingTime = new Date().getTime() - this.startTimestamp;

        const timeToWait = threshold - loadingTime;

        if (timeToWait <= 10) {
          this.loaded = true;
        } else {
          this.$timeout(() => {
            this.loaded = true;
          }, timeToWait);
        }
      });
    }
  },
  template: `
    <div class="loading" ng-class="{ '-loaded': $ctrl.loaded && !$ctrl.LoadingService.isLoading, '-long-operation': $ctrl.LoadingService.viewParams.longOperation }">
      <div class="content">
        <h1 translate="{{ $ctrl.LoadingService.viewParams.token }}"></h1>
        <div class="progress-bar"></div>
        <p translate="loading.long_operation_notice"></p>
      </div>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/loading.js